import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import RegulationWrapper from './RegulationResults';
import APHWrapper from './Aph';



const Regulation = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'Regulação',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/regulation-results`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'APH',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/aph`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        }
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/regulation-results`]:
            'Regulação',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/aph`]:
            'APH'
    };

    const subtitleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/regulation-results`]:
            'Ocorrências por tipo de regulação',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/aph`]:
            'Ocorrência por tipo de APH - Atendimento Pré-Hospitalar (Regulação)'
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                    subtitle={subtitleMap[location.pathname]}
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="regulation-results" replace />}
                        />
                        <Route
                            path="regulation-results"
                            element={<RegulationWrapper />}
                        />
                        <Route
                            path="aph"
                            element={<APHWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Regulation;

